import { tStr } from '@src/shared/utils/lang'
import { selectToken } from '@store/user/reducer'

const parseAuthToken = token => {
  if (token) {
    const buffer = Buffer.from(token.split('.')[1], 'base64')
    return JSON.parse(buffer.toString())
  }

  return {}
}

export const stateRequest = state => {
  const {
    sourceRequest: { coreApi }
  } = state
  const token = selectToken(state)
  const { account_id: accountId } = parseAuthToken(token)

  return {
    accountId,
    coreApi,
    token
  }
}

export const translateErrorMsg = (msg: string) => {
  return msg.endsWith('_s') ? tStr(msg) : msg
}

export const handleError = error => ({
  message: translateErrorMsg(error.response?.data?.message || error.message),
  errors: error.response?.data?._embedded?.errors || error._embedded?.errors,
  status: error.response?.status,
  warnings: error.response?.data?.warnings || error.warnings
})

export const values = elements =>
  Array.from(elements)
    // @ts-expect-error -- need to filter out non-input elements TODO fix
    .filter(element => element.name)
    .reduce((agg, element) => {
      // @ts-expect-error -- TODO fix
      const { name, value } = element
      agg[name] = name === 'telephone' ? value.replace(/\D/g, '') : value
      return agg
    }, {})
